import React, { Fragment, useRef } from "react";
import { useState } from "react";
import Slider from "react-slick";

const Pricing = (props) => {

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        responsive: [
            {
                breakpoint: 580,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ]
    };

    const settings2 = {
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        touchMove: false,
        swipe: false,
        swipeToSlide: false,
        draggable: false,
        responsive: [
            {
                breakpoint: 580,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ]
    };

    const slider1 = useRef(null);
    const [nav1] = useState();
    const [nav2, setNav2] = useState();

    const previous = () => {
        slider1.current.slickNext();
    };

    const next = () => {
        slider1.current.slickPrev();
    };
    return (
        <Fragment>
            <section>
                <div className="container">
                    <div className="row">
                        <div className="col-md-5 text-center text-md-left mb-4 mb-md-0">
                            <h1 className="bold font__size--40 text__40-1024 text__40-md text__40-mm">Plans for project teams</h1>
                            <p className="normal font__size--16 text__16-1024 color__gray-2">Start with core project control, then scale into configurable operations.
                            </p>

                        </div>
                        <div className="col-md-7 position-relative">
                            <div className="wrapper__arrow d-md-none">
                                <svg onClick={next} className="pointer left" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_65_640)">
                                        <path d="M13.8299 19C13.6805 19.0005 13.5329 18.9675 13.3979 18.9035C13.263 18.8394 13.144 18.746 13.0499 18.63L8.21992 12.63C8.07284 12.451 7.99243 12.2266 7.99243 11.995C7.99243 11.7633 8.07284 11.5389 8.21992 11.36L13.2199 5.35997C13.3897 5.15575 13.6336 5.02733 13.898 5.00295C14.1624 4.97857 14.4257 5.06023 14.6299 5.22997C14.8341 5.39971 14.9626 5.64362 14.9869 5.90805C15.0113 6.17247 14.9297 6.43575 14.7599 6.63997L10.2899 12L14.6099 17.36C14.7322 17.5068 14.8099 17.6855 14.8338 17.875C14.8576 18.0646 14.8267 18.257 14.7447 18.4295C14.6626 18.6021 14.5328 18.7475 14.3707 18.8486C14.2086 18.9497 14.021 19.0022 13.8299 19Z" fill="#CDCCD0" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_65_640">
                                            <rect width="24" height="24" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                <svg onClick={previous} className="pointer right" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_65_635)">
                                        <path d="M10.0001 19C9.7664 19.0005 9.53996 18.9191 9.36005 18.77C9.25879 18.6861 9.17509 18.583 9.11374 18.4666C9.05239 18.3503 9.01459 18.223 9.00251 18.092C8.99044 17.961 9.00432 17.8289 9.04337 17.7033C9.08241 17.5777 9.14585 17.4611 9.23005 17.36L13.7101 12L9.39005 6.63C9.30699 6.52771 9.24495 6.41002 9.20752 6.28368C9.17009 6.15734 9.158 6.02485 9.17194 5.89382C9.18587 5.76279 9.22557 5.63581 9.28875 5.52017C9.35192 5.40454 9.43732 5.30252 9.54005 5.22C9.64352 5.12897 9.76468 5.0603 9.89595 5.01831C10.0272 4.97632 10.1657 4.96192 10.3028 4.976C10.4399 4.99009 10.5726 5.03236 10.6926 5.10016C10.8126 5.16796 10.9173 5.25983 11.0001 5.37L15.8301 11.37C15.9771 11.5489 16.0575 11.7734 16.0575 12.005C16.0575 12.2366 15.9771 12.4611 15.8301 12.64L10.8301 18.64C10.7297 18.761 10.6023 18.8567 10.4581 18.9192C10.3139 18.9818 10.157 19.0095 10.0001 19Z" fill="#CDCCD0" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_65_635">
                                            <rect width="24" height="24" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>

                            </div>
                            <Slider asNavFor={nav2} ref={slider1} {...settings} className="wrapper__slider-pricing">
                                <div className="text-center items">
                                    <h5 className="bold font__size--20">Core</h5>
                                    <p className="normal font__size--16 text__16-1024 color__gray-2">Project, workers, milestones and <br className="d-none d-xl-block" /> task management.</p>

                                    <h4 className="bold font__size--40 text__40-1024 text__40-md text__40-mm">Core<span className="bold font__size--14">/Plan</span></h4>
                                </div>
                                <div className="text-center items">
                                    <h5 className="bold font__size--20">Platform</h5>
                                    <p className="normal font__size--16 text__16-1024 color__gray-2">Builder, permissions, automations <br className="d-none d-xl-block" /> and analytics.</p>

                                    <h4 className="bold font__size--40 text__40-1024 text__40-md text__40-mm">Scale<span className="bold font__size--14">/Plan</span></h4>
                                </div>
                            </Slider>
                        </div>
                    </div>
                    <hr />
                    <div className="row">
                        <div className="col-7 col-md-5 px-xx-10">
                            <ul className="wrapper__list-pricing list">
                                <li className="semi-bold font__size--16 text__16-1024">Projects, milestones and tasks</li>
                                <li className="semi-bold font__size--16 text__16-1024">Workers and member roles</li>
                                <li className="semi-bold font__size--16 text__16-1024">Ledger and payment requests</li>
                                <li className="semi-bold font__size--16 text__16-1024">Procurement and purchase orders</li>
                                <li className="semi-bold font__size--16 text__16-1024">Client updates and approvals</li>
                                <li className="semi-bold font__size--16 text__16-1024">Builder and automations</li>
                            </ul>
                        </div>
                        <div className="col-5 col-md-7 px-xx-10">
                            <Slider asNavFor={nav1}
                                ref={(slider2) => setNav2(slider2)} {...settings2} className="wrapper__slider-pricing">
                                <div className="items text-center wrapper__hover-card">
                                    <ul className="wrapper__list-pricing nolist mb-5 px-0 mx-0">
                                        <li><img className="mx-auto" src="./../images/sdasd.png" alt="" /></li>
                                        <li><img className="mx-auto" src="./../images/sdasd.png" alt="" /></li>
                                        <li><img className="mx-auto" src="./../images/sdasd.png" alt="" /></li>
                                        <li><img className="mx-auto" src="./../images/sascircle.png" alt="" /></li>
                                        <li><img className="mx-auto" src="./../images/sascircle.png" alt="" /></li>
                                        <li><img className="mx-auto" src="./../images/sascircle.png" alt="" /></li>
                                    </ul>
                                    <a href="#!" className="btn btn__outlined--green btn__pricing font__size--16 text__16-1024 w-100 semi-bold color__black h__black no__opacity shadow rounded__50">Start with core</a>
                                </div>
                                <div className="items text-center wrapper__hover-card">
                                    <ul className="wrapper__list-pricing nolist mb-5 px-0 mx-0">
                                        <li><img className="mx-auto" src="./../images/sdasd.png" alt="" /></li>
                                        <li><img className="mx-auto" src="./../images/sdasd.png" alt="" /></li>
                                        <li><img className="mx-auto" src="./../images/sdasd.png" alt="" /></li>
                                        <li><img className="mx-auto" src="./../images/sdasd.png" alt="" /></li>
                                        <li><img className="mx-auto" src="./../images/sdasd.png" alt="" /></li>
                                        <li><img className="mx-auto" src="./../images/sdasd.png" alt="" /></li>
                                    </ul>
                                    <a href="#!" className="btn btn__outlined--green btn__pricing font__size--16 text__16-1024 w-100 semi-bold color__black h__black no__opacity shadow rounded__50">Choose platform</a>
                                </div>

                            </Slider>
                        </div>
                    </div>
                </div>
            </section>
        </Fragment>
    );
};

export default Pricing;
